export default __webpack_public_path__ + "audio/bloop.cbaa7931.mp3";